import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { MantineProvider } from '@mantine/core';

// CSS layer order is fixed: core -> code-highlight, then our token/font/base
// styles last so var(--token) overrides land on top (see CLAUDE.md gotcha).
import '@mantine/core/styles.css';
import '@mantine/dropzone/styles.css';
import './theme/tokens.css';
import './theme/fonts.css';
import './theme/app.css';

import { e9lMantineTheme } from './theme/mantine-theme';
import { AdsProvider } from './ads/AdsContext';
import { App } from './App';

const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('Root element #root not found');

createRoot(rootEl).render(
  <StrictMode>
    <MantineProvider theme={e9lMantineTheme} defaultColorScheme="dark" forceColorScheme="dark">
      <AdsProvider>
        <BrowserRouter basename="/imgconv">
          <App />
        </BrowserRouter>
      </AdsProvider>
    </MantineProvider>
  </StrictMode>,
);
